import wx from "weixin-js-sdk";

export default defineNuxtPlugin({
  name: "weixin-js-sdk-plugin",
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.provide("wx", wx);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $wx: typeof wx;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $wx: typeof wx;
  }
}
